<span
  class="problematic-icon"
  *ngIf="this.member?.isProblematic"
  [matTooltip]="getToolTip"
  ><mat-icon>{{ getIcon }}</mat-icon>
</span>
